import { useEffect, useRef, useState } from 'react';
import { TokenTypes } from '../constants/constants';
import Security from '../additiv-services/services/core/security';
import getStorageTokensConfig from '../configs/storage-tokens-config';

export function CheckExpiredSessionStorageTokens() {
    const storageTokensConfig = getStorageTokensConfig();

    const [heartBeat, setHeartBeat] = useState(storageTokensConfig.heartBeat);
    const [runOnce, setRunOnce] = useState(!storageTokensConfig.runOnce);

    useInterval(() => {
        CheckSessionStorageTokens();
    }, runOnce ? heartBeat : null);
}

function CheckSessionStorageTokens() {
    const storageTokensConfig = getStorageTokensConfig();

    let allTokenFoundInCache = true;
    let oneTokenIsExpired = false;

    if (storageTokensConfig.showLogs) { console.log('CheckSessionStorageTokens'); }

    Object.keys(TokenTypes).forEach((key: string) => {
        if (storageTokensConfig.showLogs) { console.log(`Checking token type: ${key} in session storage.`); }

        if (!Security.GetCachedTokenByType(key)) {
            allTokenFoundInCache = false;
        }

        if (Security.isTokenExpired(Security.GetCachedTokenByType(key))) {
            oneTokenIsExpired = true;
        }
    });

    if (!allTokenFoundInCache || oneTokenIsExpired) {
        Security.generateApplicationTokensIfNeeded();

        if (storageTokensConfig.showLogs) { console.log(`All tokens found in cache: ${allTokenFoundInCache}. One token is expired: ${oneTokenIsExpired}.`); }
    }
}

function useInterval(callback, delay) {
    const intervalRef = useRef<number | null>(null);
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const tick = () => savedCallback.current();

        if (typeof delay === 'number') {
            intervalRef.current = window.setInterval(tick, delay);

            return () => {
                if (intervalRef.current !== null) {
                    window.clearInterval(intervalRef.current);
                }
            };
        }
    }, [delay]);

    return intervalRef;
}
